const RouteConstants: any = {
    root: '/',
    login: '/login',
    explore: '/explore',
    update_password: '/update-password',
    no_poi: '/no-poi',
    catchments: '/catchments',
    dashboard: '/dashboard',
    stories: '/stories',
    story_details: '/story-details',
    profile: '/profile',
    settings: '/settings',
    users: '/users',
    families: '/families',
    something_went_wrong: '/something-went-wrong',
    error: '/error',
    not_found: '/not-found',
    help: '/help',
    compare:'/compare',
    wip :'/wip',
    releases: '/releases',
    layers: '/layers'
}

export { RouteConstants };